import {
  PolicyStatementType,
  PolicyType,
  policyConfig,
} from "shared";

import { fieldIsValid } from "../../../../../lib/helper";
import { CurrencyInput } from "../../../../../../common/Atoms/CurrencyInput";

import { IFieldProps } from "./fieldProps";

const config = policyConfig.minimum_threshold;

export function MinimumDue({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  function getDescription() {
    if (policyFormData.policy_type === PolicyType.STATEMENT) {
      return `Do not send a statement if the balance is less than this amount. (In Statement Currency)`;
    }

    if (policyFormData.policy_type === PolicyType.CONTACT_ESCALATION) {
      return `Apply this policy when the contact has at least this amount overdue on their account.`;
    }

    if (policyFormData.policy_type === PolicyType.STATEMENT_LATE_FEE) {
      if (policyFormData.statement_type === PolicyStatementType.OUTSTANDING) {
        return `Apply this policy when the contact has at least this amount outstanding on their account. (In your organisations base currency)`;
      }

      if (policyFormData.statement_type === PolicyStatementType.OVERDUE) {
        return `Apply this policy when the contact has at least this amount overdue on their account. (In your organisations base currency)`;
      }
    }

    return `Apply this policy when at least this amount is overdue on the invoice`;
  }

  function getLabel() {
    if (policyFormData.policy_type === PolicyType.STATEMENT || policyFormData.policy_type === PolicyType.STATEMENT_LATE_FEE) {
      if (policyFormData.statement_type === PolicyStatementType.OUTSTANDING) {
        return `Minimum Outstanding Amount`;
      }

      if (policyFormData.statement_type === PolicyStatementType.OVERDUE) {
        return `Minimum Overdue Amount`;
      }
    }

    if (policyFormData.policy_type === PolicyType.CONTACT_ESCALATION ) {
      return `Minimum Overdue Amount`;
    }

    return config.label;
  }

  return (
    <CurrencyInput
      label={ getLabel() }
      helpIcon={ getDescription() }
      value={ policyFormData.minimum_threshold }
      onChange={ handleChange }
      name={ `minimum_threshold` }
      invalid={ fieldIsValid(`minimum_threshold`, invalids) }
    />
  );
}
